import type { ReactElement } from "react";
import type { ElementProps } from "../functionalComponents/RenderPage";

import { calculateResponsiveTable } from "./calculateResponsiveTable";
import { calculateLandscapeRowsAndColumns } from "./calculateLandscapeRowsAndColumns";
import { calculatePortraitRowsAndColumns } from "./calculatePortraitRowsAndColumns";
import type { ContentContext, GridObject } from "./gridTypes";

export type { GridObject };

function calculateRowsAndColumns(
  elements: ReactElement<ElementProps>[],
  isInLandscape: boolean,
  singleColumnInPortrait: boolean,
  contentContext?: ContentContext,
): GridObject[] {
  const hasColumnTitles = elements.some(el => el.props.type === "columnTitle:");

  if (hasColumnTitles) {
    return calculateResponsiveTable(elements, isInLandscape);
  }

  if (isInLandscape || !singleColumnInPortrait) {
    return calculateLandscapeRowsAndColumns(elements, contentContext);
  }

  return calculatePortraitRowsAndColumns(elements);
}

export default calculateRowsAndColumns;